export default httpClient => ({
    save: async ({ nome, email, password, status, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.post('/contatos', {
            nome,
            email,
            password,
            status,
        }, { headers })
        return {
            data: response.data,
        }
    },
    update: async ({ id, nome, email, password, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.patch('/contatos/' + id, {
            id,
            nome,
            email,
            password
        }, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/contatos/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/contatos', { headers });
        return { data: response.data }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/contatos/' + id, { headers });
        return {
            data: response
        }
    },
});